export const isValidPhoneNumber = (phoneNumber: string) => /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(phoneNumber);
